import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Skip if navigating to an in-page anchor (e.g., #faq)
    if (hash) return;

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const scrollToTop = () => {
      // Temporarily disable smooth scroll to force instant jump
      const html = document.documentElement;
      const prevBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';

      window.scrollTo(0, 0);
      html.scrollTop = 0;
      document.body.scrollTop = 0;

      // Restore smooth scroll behavior on next tick
      requestAnimationFrame(() => {
        html.style.scrollBehavior = prevBehavior;
      });
    };

    // Run immediately for synchronous routes
    scrollToTop();

    // Run again after Suspense resolves and content paints
    // (covers lazy-loaded pages like ServiceDetails)
    const raf1 = requestAnimationFrame(() => {
      scrollToTop();
      const raf2 = requestAnimationFrame(scrollToTop);
      // Final safety net after layout settles
      const timeout = window.setTimeout(scrollToTop, 100);
      return () => {
        cancelAnimationFrame(raf2);
        clearTimeout(timeout);
      };
    });

    return () => cancelAnimationFrame(raf1);
  }, [pathname, hash]);

  return null;
}
